// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__3e9Wb","col":"CardReaderDesc_col__dszUY","label":"CardReaderDesc_label__3W2SA"};